<template>
  <a-dropdown>
    <a-icon type="global" style="padding: 0 12px;cursor: pointer"/>
    <a-menu
      :default-selected-keys="[currentLanguage]"
      slot="overlay"
      @click="changeLanguage">
      <a-menu-item :key="language.code" v-for="language in languages">
        <a href="javascript:;">
          <i :class="language.icon"></i>
          {{ language.name }}</a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>

export default {
  name: 'SelectLang',
  data() {
    return {
      languages: this.$store.getters.getLanguages(),
      currentLanguage: this.$store.getters.getLanguage(),
      currentLanguageClass: 'flag-icon flag-icon-cn',
    };
  },
  created() {
  },
  methods: {
    changeLanguage({ key }) {
      localStorage.setItem('language', key);
      this.$message
        .loading('Action in progress..', 0.5)
        .then(() => {
          window.location.reload();
        });
    },
  },
};
</script>

<style scoped>

</style>
